import {
	AfterViewInit,
	Component,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { NgFor } from '@angular/common';

@Component({
	selector: 'app-ach-checks',
	templateUrl: './ach-checks.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./ach-checks.component.scss'],
	imports: [NgFor],
})
export class AchChecksComponent implements OnInit, AfterViewInit {
	automated_payments_ne: any;
	double_payment_res: any;
	constructor(private apiService: LegacyApiService) {}
	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.apiService.getLGACHCompanyNEACH().subscribe((res) => {
			this.automated_payments_ne = res;
		});

		this.apiService.getDoublePayments().subscribe((res) => {
			this.double_payment_res = res;
		});
	}
}
